// Module
var code = "<div class=\"gc-close\" style=\"--gc-close-foreground: {{iconCloseColor}};\" @click=\"stop({ event: $event })\"></div>";
// Exports
export default code;